import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TableDataResponse } from 'types/general';
import { IPermission, IRole } from 'types/income';
import {
  AccessLevel,
  PermissionName,
  PermissionRolesFilters,
} from './permissions.types';

interface GetRoles {
  filters: Partial<PermissionRolesFilters>;
}

interface CreateRole {
  name: string;
  description: string;
  permissions: Array<{
    permission: PermissionName;
    accessLevel: AccessLevel;
  }>;
}

interface UpdateRole {
  roleId: string;
  data: Partial<CreateRole>;
}

interface DeleteRole {
  roleId: string;
}

interface CopyRole {
  roleId: string;
  data: {
    name: string;
  };
}

interface BulkUpdateRolePermissions {
  permissions: Array<{
    roleId: string;
    permission: PermissionName;
    accessLevel: AccessLevel;
  }>;
}

export const loaders = {
  getRoles: ({ filters }: GetRoles) => {
    return api<TableDataResponse<IRole>>({
      url: Endpoints.clientAdmin.permissions.roles.root,
      params: {
        search: filters.search || undefined,
        filter: {
          roleIds: filters.roleIds,
        },
      },
    });
  },
  getPermissions: () => {
    return api<TableDataResponse<IPermission>>({
      url: Endpoints.clientAdmin.permissions.permissions,
    });
  },
  createRole: (data: CreateRole) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.permissions.roles.root,
      data,
      method: 'post',
    });
  },
  updateRole: ({ roleId, data }: UpdateRole) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.permissions.roles.byId.replace(
        ':roleId',
        roleId,
      ),
      data,
      method: 'patch',
    });
  },
  deleteRole: ({ roleId }: DeleteRole) => {
    return api({
      url: Endpoints.clientAdmin.permissions.roles.byId.replace(
        ':roleId',
        roleId,
      ),
      method: 'delete',
    });
  },
  copyRole: ({ roleId, data }: CopyRole) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.permissions.roles.copy.replace(
        ':roleId',
        roleId,
      ),
      data,
      method: 'post',
    });
  },
  bulkUpdateRolePermissions: (data: BulkUpdateRolePermissions) => {
    return api({
      url: Endpoints.clientAdmin.permissions.roles.bulkUpdate,
      data,
      method: 'patch',
    });
  },
};
